import DrawerBasic, { IDrawerBasicProps } from "@/Components/Base/Drawer/DrawerBasic";
import TituloPagamentoForm from "./TituloPagamentoForm";

export interface ITituloPagamentoFormDrawerProps extends Omit<IDrawerBasicProps, "elementoGatilho"> {
    codTitulo : number;
}
export default function TituloPagamentoFormDrawer ({
    codTitulo,
    children,
    destroyOnClose,
    ...rest
}:ITituloPagamentoFormDrawerProps) {

    return <DrawerBasic 
        {...rest} 
        elementoGatilho={children} 
        destroyOnClose={destroyOnClose ?? true}
    >
        <TituloPagamentoForm codTitulo={codTitulo} />
    </DrawerBasic>
}